var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2770_11403)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2770_11403",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.785645,
    y: -0.00830078,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2770_11403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78548 13.3249C8.41882 13.3249 8.10504 13.1944 7.84415 12.9335C7.58282 12.6722 7.45215 12.3582 7.45215 11.9915C7.45215 11.6249 7.58282 11.3109 7.84415 11.0495C8.10504 10.7886 8.41882 10.6582 8.78548 10.6582C9.15215 10.6582 9.46615 10.7886 9.72748 11.0495C9.98837 11.3109 10.1188 11.6249 10.1188 11.9915C10.1188 12.3582 9.98837 12.6722 9.72748 12.9335C9.46615 13.1944 9.15215 13.3249 8.78548 13.3249ZM8.78548 9.32487C8.41882 9.32487 8.10504 9.1942 7.84415 8.93287C7.58282 8.67198 7.45215 8.3582 7.45215 7.99154C7.45215 7.62487 7.58282 7.31087 7.84415 7.04954C8.10504 6.78865 8.41882 6.6582 8.78548 6.6582C9.15215 6.6582 9.46615 6.78865 9.72748 7.04954C9.98837 7.31087 10.1188 7.62487 10.1188 7.99154C10.1188 8.3582 9.98837 8.67198 9.72748 8.93287C9.46615 9.1942 9.15215 9.32487 8.78548 9.32487ZM8.78548 5.32487C8.41882 5.32487 8.10504 5.1942 7.84415 4.93287C7.58282 4.67198 7.45215 4.3582 7.45215 3.99154C7.45215 3.62487 7.58282 3.31109 7.84415 3.0502C8.10504 2.78887 8.41882 2.6582 8.78548 2.6582C9.15215 2.6582 9.46615 2.78887 9.72748 3.0502C9.98837 3.31109 10.1188 3.62487 10.1188 3.99154C10.1188 4.3582 9.98837 4.67198 9.72748 4.93287C9.46615 5.1942 9.15215 5.32487 8.78548 5.32487Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2770_11403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEllipsis);
export default __webpack_public_path__ + "static/media/open-ellipsis.d0f9bcf5f42c179812dc1cb72274c9d4.svg";
export { ForwardRef as ReactComponent };